/* eslint-disable react/require-default-props, react/no-unused-prop-types */
import React, { useCallback } from 'react';
import { MultiSelectBase } from '../MultiSelectBase';
import { Avatar } from '../../Avatar';
import './MultiSelectFilterWithAvatarStyles.scss';
/**
 * MultiSelectFilterWithAvatar
 * Multi-select popup filter where each option renders an avatar beside the label.
 * Parity with legacy `MultiSelectWithAvatar.jsx`.
 * @version 1.0.0
 * @since 2026-05-04
 */
export function MultiSelectFilterWithAvatar({ label, value, onChange, options, placeholder, disabled, showReset, includeInactive, onIncludeInactiveChange, includeInactiveLabel }) {
    const renderOption = useCallback((opt) => (React.createElement("span", { className: "multi-select-with-avatar__option" },
        React.createElement(Avatar, { label: opt.label, src: opt.avatarUrl, color: opt.color, size: "24" }),
        React.createElement("span", { className: "qmb-ui-multi-select-base__option-text" },
            React.createElement("span", { className: "qmb-ui-multi-select-base__option-label" }, opt.label),
            opt.subtitle && React.createElement("span", { className: "qmb-ui-multi-select-base__option-subtitle" }, opt.subtitle)))), []);
    return (React.createElement(MultiSelectBase, { label: label, value: value, onChange: onChange, options: options, placeholder: placeholder, disabled: disabled, showReset: showReset, renderOption: renderOption, includeInactive: includeInactive, onIncludeInactiveChange: onIncludeInactiveChange, includeInactiveLabel: includeInactiveLabel }));
}
